<template>
    <div>
        <!-- begin breadcrumb -->
        <ol class="breadcrumb float-xl-right">
            <li class="breadcrumb-item active"><a href="javascript:;">Detalle Entrega Chips</a></li>
        </ol>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h1 class="page-header">Detalle Entrega Chip: <b>{{this.$route.params.chip}}</b> </h1>
        <!-- end page-header -->
        <!-- begin panel -->
        <!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
        <!-- end panel -->
        <!-- begin card -->
        <div class="card  border-0 ">
            <div class="card-body">
                <!-- <button type="button" class="btn btn-warning " @click="confirmar()"> <i class="fa fa-arrow-left"></i> Regresar </button> &nbsp; -->
                <router-link v-show="this.$route.params.btn_regresar==null" class="btn btn-warning " to="/entregas/chip" > <i class="fa fa-arrow-left"></i> Regresar</router-link>
 &nbsp;
            <button v-show="this.$route.params.btn_regresar!=null" @click="$router.go(-1)" class="btn btn-warning " > <i class="fa fa-arrow-left"></i> Regresar</button>
 &nbsp;
            <router-link v-show="this.$route.params.btn_regresar!=null" class="btn btn-success" to="/entregas/chip" > <i class="fa fa-home"></i> Modulo Inicial</router-link>
 &nbsp;
                <button type="button" class="btn btn-primary " @click="confirmar()"> <i class="fa fa-save"></i> Guardar
                    Datos </button>
                &nbsp;
                <!-- <input v-validate="'required'"   :data-vv-name="'uo'"    v-model="prueba"   type="text">
<span>{{ errors.first('uo') }}</span> -->

                <!-- <span>{{ errors.first('111') }}</span> -->
                <!-- <span v-show="errors.has('111')" class="required text-danger"> -->
                <!-- {{ errors['items'][0].msg }} -->
                <!-- </span> -->

                <!-- <error :attribute_name="'111'" :errors_form="errors" /> -->
            </div>
        </div>
        <!-- begin row -->
        <div class="row animated fadeIn">
            <!-- begin col-12 -->
            <div class="col-xl-12">
                <br>
                <table class="table align-middle">
                    <thead class="bg bg-white">
                        <tr>
                            <th class="h4">APELLIDOS Y NOMBRES DEL VENDEDOR</th>
                            <th class="text-center h4">CHIP</th>
                           
                            <th class="text-center h4">ESTADO</th>
                             <th class="text-center h4">TIPO COMISION</th>
                             <th class="text-center h4">MONTO  COMISION</th>
                            <th class="text-center h4">FECHA VENTA</th>
                            <th class="text-center h4">FECHA REGISTRO</th>
                        </tr>
                    </thead>
                    <br>
                    <tbody>
                        <tr class="bg-yellow" v-for="c in chips" :key="c.Id">
                            <!-- <tr v-for="c in chips" :key="c.Id"> -->
                              <th  class=" h4">{{c.vendedor}} -- <small><i> 
                                <!-- {{c.tipo_vendedor ==1 ? 'FFVV' : c.tipo_vendedor ==2 ?  'PDV' :  'SIN DEFINIR'}} -->
                                {{ filtrar(c.tipo_vendedor)}}
                                </i></small> </th>
                            <th class="text-center h4">{{c.chip}}</th>
                         
                            <td>
                                <select data-vv-name="'estado'" v-validate="'excluded:0'" ref="estadochip" :disabled="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00' && c.monto!=null "
                                    v-model="c.estado" class="form-control">
                                    <option value="1">VENDIDO</option>
                                    <option value="2">ANULADO</option>
                                    <error :attribute_name="'estado'" :errors_form="errors" />
                                </select>
                            </td>
                               <td>
                                
                                <select v-if="c.estado<2"   :key="c.Id" :id="c.Id" :data-vv-name="'comision-del-chip-'+c.chip" :disabled="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00' && c.monto!=null"
                                 v-validate="'excluded:0'" 
                                 class="form-control font-weight-bold" v-model="c.tipo_comision">
                                <!-- <select :key="c.Id" :id="c.Id"  :disabled="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00'"
                                 v-validate="'required|excluded:0'" :data-vv-name="'comision-del-chip-'+c.chip"
                                    class="form-control font-weight-bold" v-model="c.tipo_comision"> -->
                                    <option value="0">Seleccione tipo de comisión...</option>
                                    <option v-for="d in comboComisionChip" :key="d.Id" :value="d.Id">
                                         {{c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00' ? d.comision:d.comision+' - '+d.monto}}</option>
                                </select>
                             
                                <error :attribute_name="'comision-del-chip-'+c.chip" :errors_form="errors" />
                            </td>
                             <th class="h4 text-center">
                               S/. {{c.monto}}
                            </th>
                            <th
                                :class="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00'  ?   'text-center bg-warning rounded' : c.estado=='2' ? 'text-center bg-primary rounded' : 'text-center'">
                                <input v-show="c.estado==1  && c.monto==null" class="form-control" type="date"  v-model="c.fecha_venta">
                                <span v-show="c.fecha_venta!='' && c.monto!=null">{{c.fecha_venta}}</span>
                            </th>
                            <th class="text-center">{{ c.fecha_registro}}</th>
                        </tr>
                    </tbody>
                </table>
                <procesando v-if="proceso" />
            </div>
            <!-- end col-12 -->
        </div>
        <!-- end row -->
    </div>
</template>
<script>
    import comision from '../components/compartidos/SelectComision'
    import registros from '../components/compartidos/Registros'
    import procesando from '../components/compartidos/Procesando'
    import axios from 'axios'
    import error from '../components/compartidos/Error'
    export default {
        name: "EntregaDetalleChip2",
        components: {
            comision,
            registros,
            procesando,
            error
        },
        beforeMount() {
            this.cargarDetalle();
        },
        data() {
            return {
                prueba: "000",
                proceso: false,
                nuevo: true,
                entregaChip: null,
                nuevoEntregaChip: 0,
                counter: 0,
                forms: [],
                detalles: [],
                totalRecords: 0,
                chips: [],
                chip: {
                    chip: '',
                    fecha_registro: '',
                    dni_admin: '',
                    dni_vendedor: '',
                    vendedor: '',
                    tipo_comision: '',
                    fecha_venta: '',
                    monto: '',
                    estado: '0',
                    tipo_vendedor:''
                }

            }
        },
        methods: {
            alert(a) {
                alert(a);
            },
            cargarDetalle() {
                this.proceso = true;
                axios.post(this.URL_BASE() + "detalle_ventas_chip/read_chip/" + this.$route.params.chip).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                    if (respuesta.data.msg == 'exito') {
                        // this.chips=[...respuesta.data.data]
                        respuesta.data.data.forEach(element => {
                            this.chip = {
                                ...element
                            }
                            this.chips.push(this.chip);
                           
                            if(this.chips[0]['estado']==2){
                                 this.chips[0]['estado']=2;
                            }else{
                                 this.chips[0]['estado']=1;
                            }
                        });
                    }
                    this.proceso = false;
                }).catch( (error)=> {
                    console.log("er store" + error);
                });
            },
            filtrar(tipo){
			  let nuevoTipo=this.$store.state.dataTipoVendedor.filter(elemento=>elemento.Id==tipo);

			  return nuevoTipo[0].tipo;
			},
            cargarDetalle() {
                this.proceso = true;
                axios.post(this.URL_BASE() + "detalle_ventas_chip/read_chip/" + this.$route.params.chip).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                    if (respuesta.data.msg == 'exito') {
                        // this.chips=[...respuesta.data.data]
                        respuesta.data.data.forEach(element => {
                            this.chip = {
                                ...element
                            }
                            this.chips.push(this.chip);
                           
                            if(this.chips[0]['estado']==2){
                                 this.chips[0]['estado']=2;
                            }else{
                                 this.chips[0]['estado']=1;
                            }
                        });
                    }
                    this.proceso = false;
                }).catch( (error)=> {
                    console.log("er store" + error);
                });
            },
            guardar() {
                this.proceso = true;

                axios.put(this.URL_BASE() + "detalle_ventas_chip/update/", this.chips).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                    if (respuesta.data.msg == 'exito' || respuesta.data.msg == 'vacio') {
                        this.exito("Guardado correctamente");
                        setTimeout(() => {
                            this.$router.push('/entregas/chip/registrar'); 
                        }, 100);
                    }
                    this.proceso = false;
                }).catch( (error) =>{
                    console.log("er store" + error);
                });
            },
            confirmar() {

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // let a = await this.confirmar();
                        this.$swal({
                            title: '¿Está seguro?',
                            text: 'Se guardará todos los datos',
                            type: 'warning',
                            showCancelButton: true,
                            buttonsStyling: false,
                            confirmButtonText: 'Confirmar',
                            cancelButtonText: 'Cancelar',
                            confirmButtonClass: 'btn m-r-5 btn-warning',
                            cancelButtonClass: 'btn btn-default',
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.value) {
                                this.guardar();
                                // this.$swal('Proceso confirmado', '', 'success')
                                return true;
                            } else if (result.dismiss) {
                                return false;
                                // Swal.fire('Changes are not saved', '', 'info')
                            }
                        })
                    } else {
                        console.log('sd');
                    }
                });

            },
            eliminar(registros) {
                this.proceso = true;
                axios.post(this.URL_BASE() + "entrega_chip_vendedor/delete", registros).then(respuesta => {
                    if (respuesta.data.msg == 'exito') {
                        this.$swal('Proceso completado', '', 'success')
                    }
                    this.proceso = false;
                }).catch( (error) =>{
                    console.log("er store" + error);
                });
            },

        },
        computed:{
            comboComisionChip(){


                   return  this.$store.state.dataComisionChip.filter((element)=>{

                       let tipoVendedor=this.filtrar(this.chip.tipo_vendedor)
                        if(element.comision.includes(tipoVendedor)){
                            return element;
                        }
                        // if(this.chip.tipo_vendedor=='2' && element.comision.includes('PDV')){
                        //     return element;
                        // }else if(this.chip.tipo_vendedor=='1' && element.comision.includes('FFVV')){
                        //    return element; 
                        // }
                    });
                
            }
        }
    }
</script>


            

            